<ng-container *transloco="let t">
  <div class="flex h-full flex-col items-center justify-center gap-6">
    <div class="max-w-lg space-y-2 text-center">
      <h1 class="text-4xl font-bold md:text-5xl">
        {{ t('forgot-password-title') }}
      </h1>
      <p>
        {{ t('forgot-password-subtitle') }}
      </p>
    </div>
    <div class="card bg-base-100 w-full max-w-sm shadow-2xl">
      <div class="card-body">
        @if (!emailResent) {
          <form (ngSubmit)="sendResetLink()" [formGroup]="forgotPasswordForm">
            @if (resetPasswordMailExpired$$ | async) {
              <div
                class="alert alert-warning mb-4 flex items-center"
                [ngClass]="{
                  'transition-opacity': true,
                  'duration-1000': true,
                  'ease-in-out': true,
                }"
                role="alert"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 shrink-0 stroke-current"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                <span class="mx-auto">{{
                  t('forgot-password-form-error-url-expired')
                }}</span>
              </div>
            }
            <div class="space-y-1">
              <label
                class="input floating-label w-full"
                [ngClass]="{
                  'input-error':
                    forgotPasswordFormEmail?.invalid &&
                    forgotPasswordFormEmail?.touched,
                }"
              >
                <span>
                  {{ t('register-user-form-email') }}
                </span>
                <svg
                  class="h-[1em] self-center opacity-50"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <g
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke-width="2.5"
                    fill="none"
                    stroke="currentColor"
                  >
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </g>
                </svg>
                <input
                  [attr.aria-invalid]="
                    forgotPasswordFormEmail?.invalid &&
                    forgotPasswordFormEmail?.touched
                      ? true
                      : null
                  "
                  [required]="true"
                  class="w-full placeholder:opacity-50"
                  formControlName="forgotPasswordFormEmail"
                  [placeholder]="t('register-user-form-email')"
                  type="email"
                />
              </label>
              @if (
                forgotPasswordFormEmail?.invalid &&
                forgotPasswordFormEmail?.touched
              ) {
                @if (forgotPasswordFormEmail?.errors?.['email']) {
                  <p class="label-text-alt text-error">
                    {{ t('forgot-password-form-error-email-format') }}
                  </p>
                }
              }
            </div>
            @if (genericError$$ | async) {
              <div
                class="alert alert-error mt-4 flex items-center"
                [ngClass]="{
                  'opacity-100': showAlert,
                  'opacity-0': !showAlert,
                  'transition-opacity': true,
                  'duration-1000': true,
                  'ease-in-out': true,
                }"
                role="alert"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 shrink-0 stroke-current"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span class="mx-auto">{{
                  t('forgot-password-form-error-generic-error-message')
                }}</span>
              </div>
            }
            <button
              class="btn btn-primary mt-4 w-full"
              type="submit"
              [disabled]="forgotPasswordForm.invalid"
            >
              {{ t('forgot-password-form-button-reset-password') }}
            </button>
          </form>
        } @else {
          <div class="text-center">
            <p class="pb-6">
              {{ t('forgot-password-submitted-success') }}
            </p>
            <button
              class="btn btn-primary w-full"
              type="submit"
              (click)="goHome()"
            >
              {{ t('forgot-password-home-button') }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</ng-container>
